import Page from '@service-victoria/component-library/components/Page';
import Text from '@service-victoria/component-library/components/Text';
import { Button } from '@service-victoria/component-library/components/Button';
import React, { useEffect } from 'react';
import { url, constants } from 'app/utils';
import * as Styled from './styled';
import List from '@service-victoria/component-library/components/List';
import { useHistory } from 'react-router-dom';
import useActivityProvider from 'app/hooks/useActivityProvider';
import { userManager } from 'app/services';

const ChangeAuthorisedContact: React.FC = () => {
  const history = useHistory();
  const { providerDetails } = useActivityProvider();

  const handleButton = () => {
    history.push(constants.Routes.Dashboard);
  };

  useEffect(() => {
    try {
      window.scrollTo({
        top: 100,
        left: 0,
        behavior: 'smooth'
      });
    } catch (e) {
      // handle scrollTo not supporting options - IE11
      window.scrollTo(0, 100);
    }
  }, []);

  return (
    <Page
      title='Change your Get Active Kids contact'
      breadCrumbs={constants.breadCrumbs}
      headerProps={{
        ...constants.headerProps,
        ...userManager.signinHeaderProps
      }}
      showFooter>
      <Styled.Wrapper>
        <Styled.Content>
          <Text.Heading.H1 fontWeight='bold'>Change authorised contact</Text.Heading.H1>
          <Styled.Spacer24 />
          <Text.Heading.H2 fontWeight={600}>Update your details</Text.Heading.H2>
          <Text.Body>
            To update your name, email address or phone number, go to{' '}
            <Text.Link
              target='_blank'
              href={`${url.getSvDomain()}/dashboard`}
              data-testid='changeAuthorisedContact.yourServiceVictoriaSettings'>
              your Service Victoria settings page
            </Text.Link>
            .
          </Text.Body>
          <Text.Heading.H2 fontWeight={600}>Transfer your account</Text.Heading.H2>
          <Text.Body>
            You can transfer the{' '}
            <span style={{ fontWeight: 600 }}> {providerDetails?.organisation.name}</span> account
            to someone else by contacting the Department of Jobs, Skills, Industry and Regions
            (DJSIR) via:
          </Text.Body>
          <Styled.ListWrapper>
            <List
              type='disc'
              items={[
                <React.Fragment key='getActiveKidsEmail'>
                  email -{' '}
                  <Text.Link
                    target='_blank'
                    href='mailto:getactivekids@sport.vic.gov.au?subject=Transfer Get Active Kids account'
                    data-testid='changeAuthorisedContact.getActiveKidsEmail'>
                    getactivekids@sport.vic.gov.au
                  </Text.Link>
                </React.Fragment>
              ]}
            />
          </Styled.ListWrapper>
          <Text.Body>
            Include &apos;Transfer Get Active Kids account&apos; in the subject line.
          </Text.Body>
          <Styled.Spacer60 />
          <Styled.ButtonWrapper>
            <Button buttonType='secondary' onClick={handleButton}>
              Back
            </Button>
          </Styled.ButtonWrapper>
        </Styled.Content>
      </Styled.Wrapper>
    </Page>
  );
};

export default ChangeAuthorisedContact;
